<template>
  <div id="mobile-menu" class="position-fixed d-lg-none">
    <div class="container pt-sm-3">
      <div class="d-flex justify-content-end">
        <button class="navbar-toggler" type="button" @click="closeMenu">
          <img :src="close" alt="" class="w-100" />
        </button>
      </div>
      <div class="row">
        <div class="offset-1 col-5 col-sm-3 lv1 mobile-h4 fw-bold">首頁</div>
        <div class="col-6 col-sm-8 col-md-6 d-flex flex-column lv2">
          <router-link to="/" @click="closeMenu">最新消息</router-link>
          <router-link to="/apply" @click="closeMenu">線上報名</router-link>
        </div>
      </div>
      <div class="row">
        <div class="offset-1 col-5 col-sm-3 lv1 mobile-h4 fw-bold">
          培訓計畫
        </div>
        <div class="col-6 col-sm-8 col-md-6 d-flex flex-column lv2">
          <router-link to="/about" @click="closeMenu">計畫簡介</router-link>
          <!-- <router-link to="/institutes" @click="closeMenu">海外培訓機構</router-link> -->
        </div>
      </div>
      <div class="row">
        <div class="offset-1 col-5 col-sm-3 lv1 mobile-h4 fw-bold">
          研習營專區
        </div>
        <div class="col-6 col-sm-8 col-md-6 d-flex flex-column lv2">
          <router-link to="/camp-lists/phase1" @click="closeMenu"
            >各階段名單</router-link
          >
          <router-link to="/camp-courses" @click="closeMenu"
            >研習營課程及師資</router-link
          >
        </div>
      </div>
      <div class="row">
        <div class="offset-1 col-5 col-sm-3 lv1 mobile-h4 fw-bold">
          下載專區
        </div>
        <div class="col-6 col-sm-8 col-md-6 d-flex flex-column lv2">
          <router-link to="/download" @click="closeMenu">檔案下載</router-link>
        </div>
      </div>
      <div class="row">
        <div class="offset-1 col-5 col-sm-3 lv1 mobile-h4 fw-bold">
          菁培成果
        </div>
        <div class="col-6 col-sm-8 col-md-6 d-flex flex-column lv2">
          <router-link to="/records" @click="closeMenu">歷屆計畫</router-link>
          <router-link to="/online-courses" @click="closeMenu"
            >課程分享</router-link
          >
          <a
            href="//www.animlab.yuntech.edu.tw/talentpool/gallery"
            @click="closeMenu"
            >線上藝廊</a
          >
          <a
            href="//www.animlab.yuntech.edu.tw/talentpool/pool"
            @click="closeMenu"
            >菁培學員</a
          >
        </div>
      </div>
      <div class="row">
        <div class="offset-1 col-5 col-sm-3 lv1 mobile-h4 fw-bold">ENGLISH</div>
        <div class="col-6 col-sm-8 col-md-6 d-flex flex-column lv2">
          <router-link to="/en" @click="closeMenu">Introduction</router-link>
        </div>
      </div>
    </div>
  </div>
  <nav
    id="main-nav"
    class="navbar navbar-expand-lg position-fixed"
    :class="{
      full: isFullHeader,
      'has-background': hasBackground,
    }"
  >
    <div class="container nav-container align-items-start">
      <a class="d-flex navbar-brand align-items-center" href="/2021MOE/">
        <img
          id="logo"
          class="me-3 d-none d-md-inline"
          :src="logo_type"
          alt="Logo"
        />
        <img
          id="logo-mobile"
          class="me-3 d-md-none"
          :src="logo_m_type"
          alt="Logo"
        />
        <div id="program-title" class="d-flex flex-column align-items-start">
          <div class="title mobile-h3 d-flex flex-wrap">
            <div
              class="animate__animated animate__faster animate__delay-1s"
              :class="{ animate__fadeInUp: isFullHeader }"
            >
              111年度 教育部
            </div>
            <div class="flex-break d-xxl-none" />
            <div class="for-full flex-break" />
            <div
              class="animate__animated animate__faster animate__delay-2s"
              :class="{ animate__fadeInUp: isFullHeader }"
            >
              藝術與設計菁英
            </div>
            <div class="for-full flex-break" />
            <div
              class="animate__animated animate__faster animate__delay-3s"
              :class="{ animate__fadeInUp: isFullHeader }"
            >
              海外培訓計畫
            </div>
          </div>
          <div
            :class="[
              'title-en',
              'd-none',
              'd-lg-block',
              'for-full',
              'animate__animated',
              isFullHeader ? 'animate__fadeInUp' : '',
              'animate__delay-4s',
              'mobile-h4',
            ]"
          >
            MOE Scholarship Program
            <div class="flex-break d-md-none" />

            for
            <div class="flex-break d-none d-md-block d-xxl-none" />
            <div class="for-full d-none d-md-block" />
            Overseas Study in
            <div class="flex-break d-md-none" />
            Arts and Design
          </div>
          <div
            id="groups"
            class="
              text
              mobile-mini
              animate__animated animate__delay-5s
              d-none d-md-block
            "
            :class="{ animate__fadeInUp: isFullHeader }"
          >
            數位動畫組 / 視覺傳達設計組 / 時尚設計組
          </div>
        </div>
      </a>
      <div class="d-flex flex-column">
        <div>
          <button class="navbar-toggler" type="button" @click="openMenu">
            <img :src="ham_type" alt="" class="w-100 d-none d-md-inline" />
            <img :src="ham_m_type" alt="" class="w-100 d-md-none" />
          </button>
          <div
            class="
              collapse
              navbar-collapse
              justify-content-end
              align-self-start
            "
            id="navbarNav"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link class="nav-link text pt-0" to="/"
                  ><span class="link-span">最新消息</span></router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link text pt-0"
                  to="/about"
                  :class="{
                    'router-link-active': routeName === 'About',
                  }"
                  ><span class="link-span">計畫簡介</span></router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link text pt-0"
                  to="/camp-lists/phase1"
                  :class="{
                    'router-link-active': routeName.search('Camp') > -1,
                  }"
                  ><span class="link-span">錄取名單及研習營</span></router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link text pt-0"
                  to="/download"
                  :class="{ 'router-link-active': routeName == 'Download' }"
                  ><span class="link-span">下載專區</span></router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link text pt-0"
                  to="/apply-login"
                  :class="{ 'router-link-active': routeName == 'ApplyLogin' }"
                  ><span class="link-span">線上報名</span></router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link text pt-0" to="/records"
                  ><span class="link-span">菁培成果</span></router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link text pt-0"
                  to="/en"
                  :class="{
                    'router-link-active': routeName === 'AboutEn',
                  }"
                  ><span class="link-span">EN</span></router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          class="
            d-none d-lg-flex
            justify-content-end
            align-items-center
            mt-2
            not-for-full
          "
        >
          <a
            href="https://ide.ncku.edu.tw/p/426-1160-26.php?Lang=zh-tw"
            class="group-link align-items-center d-inline-flex"
            target="_blank"
            >{{ routeName === "AboutEn" ? "Product Design" : "產品設計組"
            }}<img class="link ms-1" :src="linkArrow" alt="產品設計組"
          /></a>
          <a
            href="http://sposad.cpd.ncku.edu.tw/"
            class="group-link align-items-center d-inline-flex ms-2"
            target="_blank"
            >{{
              routeName === "AboutEn"
                ? "Architeccture & Interior"
                : "建築景設組"
            }}<img class="link ms-1" :src="linkArrow" alt="建築景設組"
          /></a>
        </div>
      </div>
    </div>
    <!-- <div class="the-blur"></div> -->
  </nav>
</template>

<script>
import 'animate.css';
import logo from '@/assets/img/logo.png';
import logoW from '@/assets/img/logo_w.png';
import ham from '@/assets/img/ham.svg';
import hamW from '@/assets/img/ham_w.svg';
import close from '@/assets/img/close.svg';
import linkArrow from '@/assets/img/link_arrow_w.png';
import bootstrap from 'bootstrap/dist/js/bootstrap.min';

export default {
  data() {
    return {
      // logo,
      ham,
      close,
      linkArrow,
      isFullHeader: false,
      hasBackground: false,
    };
  },
  computed: {
    logo_type() {
      return this.hasBackground || !this.isFullHeader ? logo : logoW;
    },
    logo_m_type() {
      return this.hasBackground ? logo : logoW;
    },
    ham_type() {
      return this.hasBackground || !this.isFullHeader ? ham : hamW;
    },
    ham_m_type() {
      return this.hasBackground ? ham : hamW;
    },
    routeName() {
      const rn = this.$route.name;
      return (rn) || '';
    },
  },
  methods: {
    topMenuOnScrollHome() {
      this.hasBackground = window.scrollY > 0;
      this.isFullHeader = window.scrollY === 0;
    },
    topMenuOnScroll() {
      this.hasBackground = window.scrollY > 0;
    },
    openMenu() {
      const mobileMenu = document.getElementById('mobile-menu');
      mobileMenu.classList.add('show');
    },
    closeMenu() {
      const mobileMenu = document.getElementById('mobile-menu');
      mobileMenu.classList.remove('show');

      const bsCollapse = new bootstrap.Collapse(mobileMenu, {
        toggle: false,
      });

      bsCollapse.hide();
    },
  },
  mounted() {
    if (this.routeName === 'Home') {
      this.isFullHeader = true;
      this.hasBackground = false;
      window.removeEventListener('scroll', this.topMenuOnScroll);
      window.addEventListener('scroll', this.topMenuOnScrollHome);
    } else {
      this.isFullHeader = false;
      this.hasBackground = true;
      window.removeEventListener('scroll', this.topMenuOnScrollHome);
      window.addEventListener('scroll', this.topMenuOnScroll);
    }
  },
  watch: {
    routeName(newValue) {
      // Check if given route is true, if it is then hide Nav.
      if (newValue === 'Home') {
        // console.log(this.$route);

        this.isFullHeader = true;
        this.hasBackground = false;
        window.removeEventListener('scroll', this.topMenuOnScroll);
        window.addEventListener('scroll', this.topMenuOnScrollHome);
      } else {
        this.isFullHeader = false;
        this.hasBackground = true;
        window.removeEventListener('scroll', this.topMenuOnScrollHome);
        window.addEventListener('scroll', this.topMenuOnScroll);
      }
    },
  },
  unmounted() {
    window.removeEventListener('scroll', this.topMenuOnScrollHome);
    window.removeEventListener('scroll', this.topMenuOnScroll);
  },
};
</script>

<style lang="stylus" scoped>
#main-nav
  padding: 24px;
  background: none;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid $monoc4;

  .navbar-brand
    color: $monoc4;

  .the-blur
    display: none;

  &.has-background
    background-color: rgba(244, 243, 238, 0.9);
    // background-image: linear-gradient(
    // rgba(188, 184, 177, 0.2),
    // rgba(188, 184, 177, 0.2)
    // );
    // backdrop-filter: blur(50px);
    z-index: 500;
    margin-bottom: -10px;
    overflow: hidden;

    // transform: scale(1);
    .navbar-brand
      color: $monoc4;

    .the-blur
      display: block;

.nav-container
  z-index: 999;

.navbar-brand
  flex: 1 1 0%;

.nav-link
  color: $monoc4;

  &:focus, &:hover, &:active
    color: $monoc4;

.nav-item + .nav-item
  .nav-link
    padding-left: 24px !important;
    padding-right: 0 !important;

@media screen and (max-width: 1199.5px)
  .nav-item + .nav-item
    .nav-link
      padding-left: 8px !important;
      padding-right: 0 !important;

.router-link-active .link-span
  border-bottom: 1px solid $monoc4;

.title-en
  font-family: 'GT America', 'Noto Sans TC', sans-serif;

#logo, #logo-mobile
  width: 15%;
  max-width: 120px;
  min-width: 40px;
  height: 100%;

.group-link
  background-color: $monoc4;
  color: $monoc1;
  border-radius: 100px;
  padding: 6px 10px;
  text-decoration: none;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.05em;

  // height: 32px;
  img
    width: 18px;

.the-blur
  position: fixed;
  background: rgba(255, 255, 255, 0.7);
  top: 0;
  left: 0;
  width: 100%;
  min-height: 135px;
  z-index: 10;
  -webkit-filter: blur(10px);
  -moz-filter: blur(10px);
  -o-filter: blur(10px);
  -ms-filter: blur(10px);
  filter: blur(10px);

.for-full
  display: none;

#main-nav.full
  background: none;
  border: none;

  .not-for-full
    display: none !important;

  *
    color: $monoc4 !important;

  #logo, #logo-mobile
    display: none !important;

  // #groups
  // display: block !important;
  .title
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 58px;

  .title-en
    font-size: 1.6rem;
    font-weight: 300;
    line-height: 28px;
    margin-bottom: 8px;

  .router-link-active .link-span
    border-bottom: 1px solid $monoc4;

  .for-full
    display: block;

  .the-blur
    display: none;

@keyframes slide-up
  from
    opacity: 0.25;
    line-height: 500px;

  to
    opacity: 1;
    line-height: 25px;

.slide-up
  animation: slide-up 2s;

#mobile-menu
  width: 100vw;
  height: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1000;
  padding: 24px;
  background: rgba(70, 63, 58, 0.95);
  opacity: 0;
  overflow: hidden;
  transition: opacity 0.3s linear;
  transition-delay: 0.05s;

  &.show
    height: 100vh;
    z-index: 1000;
    opacity: 1;
    transition: opacity 0.3s linear;

  .lv1
    &, a
      color: $monoc1;
      text-decoration: none;

  .row + .row
    margin-top: 30px;

  .lv2 a
    color: $monoc2;
    text-decoration: none;
    line-height: 1.25;

    &:focus, &:hover, &:active
      text-shadow: none;

    + a
      margin-top: 18px;

// #mobile-menu.show + nav .navbar-brand
// transform: translateY(0);
.navbar-toggler
  border: none;
  z-index: 999;
  width: 36px;
  padding: 0;

  &:focus, &:hover, &:active
    box-shadow: none;

@media screen and (max-width: 1399.5px)
  .title-en
    display: none !important;

  .full
    .title-en
      display: block !important;

// @media screen and (max-width: 991.5px)
// nav
// position: fixed;
@media screen and (max-width: 767.5px)
  #main-nav:not(.full)
    .title
      font-size: 1rem !important;
      line-height: 1;

  #main-nav
    border: none;

    &.has-background
      background-color: rgba(244, 243, 238, 0.9);
      background-image: none !important;

      .the-blur
        display: none;

    .navbar-brand
      color: $monoc4;

  #main-nav.full
    .title-en
      line-height: 1 !important;
      margin-top: 4px !important;
      font-family: 'Noto Sans TC';

    .title
      line-height: 1.3 !important;
      font-weight: bold;
      font-size: 20px;

@media screen and (max-width: 575.5px)
  #main-nav:not(.full)
    .title, .title-en
      font-size: 13px !important;
      line-height: 1.3 !important;

  #main-nav.full
    .title
      font-weight: bold !important;
      font-size: 20px !important;

    .title-en
      font-size: 18px !important;
</style>

<style lang="stylus">
:root
  --animate-delay: 0.3s;
</style>
